/* global google */
import React, { useState, useEffect, useRef } from 'react';
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
  InfoWindow,
  DirectionsRenderer,
  Polyline,
} from 'react-google-maps';

import Grid from '../Grid';
// import { getGooglePlaceDetailsByPlaceID } from '../../../utils/GoogleAPI';
import { canUseDOM } from '../../../utils/canUseDOM';
import CustomInfoWindow from './infoWindow';
import { googleTheme } from './mapTheme';
// import { useTheme } from '@material-ui/core/styles';
// import { breakpoints } from '../../../../styles/themes/vad/constants';
import { EVENT_LIST_TEMPLATE_NAME } from './constants';
import { pushAnaylyticsData, createDynamicLabels } from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { GOOGLE_MAP_API } from '../../../../constants';
import { palette } from '../../../../styles/themes/vad/palette';

const MARKER_SVG =
  'M19.5,0 C8.71928571,0 0,8.764 0,19.6 C0,34.3 19.5,56 19.5,56 C19.5,56 39,34.3 39,19.6 C39,8.764 30.2807143,0 19.5,0 Z M20,27 C16.136,27 13,23.864 13,20 C13,16.136 16.136,13 20,13 C23.864,13 27,16.136 27,20 C27,23.864 23.864,27 20,27 Z';

const MARKER_SVG_FILLED =
  'M19.5,0C8.7,0,0,8.8,0,19.6C0,34.3,19.5,56,19.5,56S39,34.3,39,19.6,C39,8.8,30.3,0,19.5,0z';

const MapDirectionsRenderer = props => {
  const [directions, setDirections] = useState(null);
  const { markers, travelMode } = props;

  const wayPoints = markers.map(marker => ({
    location: { lat: marker.lat, lng: marker.lng },
    stopover: true,
  }));
  const origin = wayPoints && wayPoints.length > 0 && wayPoints.shift().location;
  const destination = wayPoints && wayPoints.length > 0 && wayPoints.pop().location;
  const directionsService = new google.maps.DirectionsService();

  directionsService.route(
    {
      origin: origin,
      destination: destination,
      travelMode: travelMode,
      waypoints: wayPoints,
    },
    (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        setDirections(result);
      }
    }
  );
  return (
    directions && (
      <DirectionsRenderer
        directions={directions}
        options={{
          polylineOptions: {
            strokeColor: 'black',
          },
          suppressMarkers: true,
        }}
      />
    )
  );
};

const WrappedMap = withScriptjs(
  withGoogleMap(props => {
    const {
      //googleMapURL,
      markers: markrs,
      polyline,
      isRouteDirection,
      isPolyline,
      //classes,
      labels,
      highlightFirstMarker = false,
      isRedMarker = false,
      contentType,
      pageName,
      componentName,
    } = props;

    const map = useRef(null);
    const mapOptions = {
      minZoom: 5
    };
    // const theme = useTheme();
    let mapZoomLevel = markrs && markrs.length > 1 ? 12 : 17;
    const [selectedMarker, setSelectedMarker] = useState(
      markrs.length > 1
        ? {
          index: 0,
          marker: markrs[0],
        }
        : null
    );
    const [markers, setMarkers] = useState(markrs);

    const bounds = canUseDOM && new window.google.maps.LatLngBounds();

    useEffect(() => {
      setMarkers(markrs);
      mapZoomLevel = markrs && markrs.length > 1 ? 12 : 17;
      setSelectedMarker(
        markrs.length === 1 || highlightFirstMarker
          ? {
            index: 0,
            marker: markrs[0],
          }
          : null
      );

      if (map.current && markrs.length > 1) {
        map.current.fitBounds(bounds);
      }
    }, [markrs]);

    // TODO: to remove this piece of code if Nearby Places not required
    // const getNearbyPlaces = () => {
    //   const pyrmont = new google.maps.LatLng(
    //     markers && markers[0].lat,
    //     markers && markers[0].lng
    //   );
    //   const request = {
    //     location: pyrmont,
    //     radius: '1000',
    //     type: ['restaurant'],
    //   };
    //   const service = new google.maps.places.PlacesService();
    //   // window.map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
    //   service.nearbySearch(request, (results, status) => {
    //     if (status === google.maps.places.PlacesServiceStatus.OK) {
    //       const nearbyMarkers = [];
    //       for (var i = 0; i < results.length; i++) {
    //         const { id, name, geometry } = results[i] || {};
    //         nearbyMarkers.push({
    //           id,
    //           name,
    //           lat: geometry.location.lat(),
    //           lng: geometry.location.lng(),
    //         });
    //       }
    //       setMarkers(currentMarkers => [...currentMarkers, ...nearbyMarkers]);
    //       console.log('nearbyMarkers', results);
    //     }
    //   });
    // };

    // TODO: fill the primary and seconday color from the theme
    const getMarkerIcon = (isActive = false) => {
      let fillColor = '';
      if (isActive) {
        if (contentType === EVENT_LIST_TEMPLATE_NAME) {
          // This comments for Event page
          fillColor = palette.common.DarkTurquoise;
          // fillColor = palette.text.secondary;
        } else {
          fillColor = palette.text.secondary;
        }
      } else {
        fillColor = palette.primary.main;
      }
      return {
        path: isRouteDirection ? MARKER_SVG_FILLED : MARKER_SVG,
        fillColor: fillColor,
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        anchor: new google.maps.Point(24, 55),
        labelOrigin: new google.maps.Point(20, 20),
      };
    };
    const addAnalyticsInfo = title => {
      const obj = {
        ...analyticsData.pageBodyInteraction.mapClick,
        ...{ label: createDynamicLabels([pageName, componentName, title]) },
      };
      pushAnaylyticsData(obj);
    };

    const makeMarkers = () => {
      return markers.map((marker, i) => {
        bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
        return (
          <Marker
            icon={
              (selectedMarker && selectedMarker.index === i) || isRedMarker
                ? getMarkerIcon(true)
                : getMarkerIcon()
            }
            key={`marker-${i}`}
            label={
              isRouteDirection
                ? { text: `${i + 1}`, color: palette.common.White, fontSize: '24px' }
                : ''
            }
            title={marker.name}
            name={marker.name}
            position={{ lat: marker.lat, lng: marker.lng }}
            onClick={() => {
              addAnalyticsInfo(marker.name);
              setSelectedMarker({ index: i, marker: marker });
            }}
          />
        );
      });
    };

    const onMapClick = () => {
      setSelectedMarker(null);
    };

    return (
      <GoogleMap
        ref={map}
        defaultCenter={{
          lat: markers && markers[0].lat,
          lng: markers && markers[0].lng,
        }}
        options={mapOptions}
        defaultZoom={mapZoomLevel}
        defaultOptions={{
          styles: googleTheme,
          streetViewControl: false,
          mapTypeControl: false,
        }}
        onClick={onMapClick}
      >
        {makeMarkers()}

        {selectedMarker && (
          <InfoWindow
            position={{
              lat: selectedMarker.marker.lat,
              lng: selectedMarker.marker.lng,
            }}
            onCloseClick={() => {
              setSelectedMarker(null);
            }}
            options={{ pixelOffset: { width: 0, height: -70 } }}
          >
            <CustomInfoWindow
              marker={selectedMarker.marker}
              labels={labels}
              componentName={componentName}
              pageName={pageName}
            />
          </InfoWindow>
        )}

        {isPolyline && (
          <Polyline
            path={polyline}
            options={{
              strokeColor: 'red',
              strokeOpacity: 0.8,
              strokeWeight: 2,
            }}
          />
        )}

        {isRouteDirection && (
          <MapDirectionsRenderer
            markers={markers}
            travelMode={google.maps.TravelMode.DRIVING}
          />
        )}

        {markers.length === 1 && (
          <div
            style={{
              position: 'absolute',
              bottom: '10px',
              left: '10px',
              zIndex: '9999',
            }}
          >
            <Grid container spacing={3}>
              {/* <Grid item>
                <Button
                  component="span"
                  buttonType="form"
                  field={{
                    value: {
                      text: 'Get Direction',
                      //href: `https://www.google.ae/maps/dir/Current+Location/${markers && markers[0].lat},${markers && markers[0].lng}`,
                      href: `https://www.google.ae/maps/dir/?api=1&destination=${markers &&
                        markers[0].lat},${markers && markers[0].lng}`,
                      target: '_black',
                    },
                  }}
                  hasBorder={false}
                />
              </Grid> */}
              {/* <Grid item>
                <div onClick={getNearbyPlaces}>
                  <Button
                    component="span"
                    buttonType="form"
                    field={{
                      value: {
                        text: 'Get Nearby Places',
                      },
                    }}
                    hasBorder={false}
                  />
                </div>
              </Grid> */}
            </Grid>
          </div>
        )}
      </GoogleMap>
    );
  })
);

const GoogleMapComponent = props => {
  return props.markers.length > 0 ? (
    <WrappedMap
      googleMapURL={`${GOOGLE_MAP_API}?key=${props.apiKey}&language=${props.language}&libraries=geometry,drawing,places`}
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height: '100%' }} />}
      mapElement={<div style={{ height: '100%' }} />}
      {...props}
    />
  ) : null;
};

export default GoogleMapComponent;
